module.exports = __webpack_public_path__ + "media/newstyle/images/info-ecd09bde2d661161e8b795cffc1b3c4b.svg";